import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMenuItem } from 'types/menu';
import { getModuleIcon, generateMenuItemId } from './utils';
import { GlobalModulesSection as Section, GlobalModuleItem, ModuleIcon, ModuleTitle } from './styles';

interface Props {
  modules: IMenuItem[];
  onItemClick: (item: IMenuItem) => void;
}

export const GlobalModulesSection: React.FC<Props> = ({ modules, onItemClick }) => {
  return (
    <Section>
      {modules
        .sort((a, b) => a.path[0].localeCompare(b.path[0]))
        .map((item) => (
          <GlobalModuleItem key={generateMenuItemId(item)} onClick={() => onItemClick(item)}>
            <ModuleIcon>
              <FontAwesomeIcon icon={getModuleIcon(item.path[0])} />
            </ModuleIcon>
            <ModuleTitle>{item.path[0]}</ModuleTitle>
          </GlobalModuleItem>
        ))}
    </Section>
  );
};
